import React from "react";

import { Text, Box } from "@chakra-ui/react";

const PassInformationItem: React.FC<{ label: string; value: string }> = ({ label, value }) => {
  const mapLabelToTestId: { [key: string]: string } = {
    "lounges.passes.voucher.name": "lounge-pass-details-name",
    "lounges.passes.voucher.qr": "lounge-pass-details-qr-number",
    "lounges.passes.voucher.expires_on": "lounge-pass-details-valid-until",
  };

  const getDataTestId = (label: string) => {
    return mapLabelToTestId[label];
  };

  return (
    <Box mb={4}>
      <Text fontSize="sm" color="greyscale.500">
        {label}
      </Text>
      <Text fontSize="md" color="primary.900" data-testid={getDataTestId(label)}>
        {value}
      </Text>
    </Box>
  );
};

export default PassInformationItem;
